export const ReturnsIconV2 = ({ width = "46" }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />
      <path
        d="M16.7725 29.7271H42.7725C47.1907 29.7271 50.7725 33.3089 50.7725 37.7271C50.7725 42.1453 47.1907 45.7271 42.7725 45.7271H32.7725"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7725 21.7271L14.7725 29.7271L22.7725 37.7271"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
